import { isSameDay } from '../../helpers/date';

type DatePickerState = {
    year: number;
    month: number;
    selected?: Date;
    time: Date; // We keep the time in a seperated date for easier computations
};

type DatePickerAction =
    | { type: 'RESET' }
    | { type: 'DECREMENT_MONTH' }
    | { type: 'INCREMENT_MONTH' }
    | { type: 'INCREMENT_TIME' }
    | { type: 'DECREMENT_TIME' }
    | { type: 'SELECT_DATE'; payload: Date };

const MINUTES_GAP = 30;

export default function reducer(
    state: DatePickerState,
    action: DatePickerAction
): DatePickerState {
    switch (action.type) {
        case 'RESET':
            return {
                ...state,
                year: new Date().getFullYear(),
                month: new Date().getMonth(),
                selected: undefined,
            };
        case 'INCREMENT_MONTH': {
            const isLastMonth = state.month === 11;
            return {
                ...state,
                year: isLastMonth ? state.year + 1 : state.year,
                month: isLastMonth ? 0 : state.month + 1,
            };
        }
        case 'DECREMENT_MONTH': {
            const isFirstMonth = state.month === 0;
            return {
                ...state,
                year: isFirstMonth ? state.year - 1 : state.year,
                month: isFirstMonth ? 11 : state.month - 1,
            };
        }
        case 'INCREMENT_TIME': {
            const newTime = new Date(state.time);
            const newMinutes = state.time.getMinutes() + MINUTES_GAP;
            if (newMinutes >= 60) {
                newTime.setMinutes(0);
                newTime.setHours(state.time.getHours() + 1);
            } else {
                newTime.setMinutes(newMinutes);
            }
            return {
                ...state,
                time: newTime,
            };
        }
        case 'DECREMENT_TIME': {
            const newTime = new Date(state.time);
            const newMinutes = state.time.getMinutes() - MINUTES_GAP;
            if (newMinutes < 0) {
                newTime.setMinutes(60 + newMinutes);
                newTime.setHours(state.time.getHours() - 1);
            } else {
                newTime.setMinutes(newMinutes);
            }
            return {
                ...state,
                time: newTime,
            };
        }
        case 'SELECT_DATE': {
            return {
                ...state,
                // Toggle selected if clicked again
                selected:
                    state.selected && isSameDay(state.selected, action.payload)
                        ? undefined
                        : action.payload,
            };
        }
    }
}
